/*
 * @Author: Teemo Ding
 * @Date: 2021-07-16 10:51:03
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-02 15:55:10
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Taxes/TaxEditPage/TaxValidCountry/CountrySelect.tsx
 */

import { Button, Modal, ModalFooter } from '@/src/components/Antd';
import { CheckCountry } from '@/src/pages/Settings/Components/SelectCountryArea';
import { Spin } from 'antd';
import React, { Fragment, useEffect, useState } from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from '../css.module.less';

const CountrySelect = ({
  value,
  onConfirm,
  list,
  getStoreCountriesLoading,
  disableEdit,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [visiable, setVisiable] = useState<boolean>(false);
  const [disable, setDisable] = useState<boolean>(true);
  const [checked, setChecked] = useState([]);
  useEffect(() => {
    setDisable(!(checked || []).length);
  }, [checked]);

  const showModal = () => {
    setVisiable(true);
    setChecked(value);
  };

  const hideModal = () => {
    setVisiable(false);
    setChecked(value);
  };

  const onModalConfirm = () => {
    onConfirm(checked);
    setVisiable(false);
  };

  const onFomValuesChange = (data) => {
    setChecked(data);
  };

  return (
    <Fragment>
      <Button type='primary' onClick={showModal} disabled={disableEdit}>
        {getI18n('storeTaxes.taxEditPage.select')}
      </Button>
      <Modal
        width={600}
        visible={visiable}
        onCancel={hideModal}
        title={getI18n('storeTaxes.taxEditPage.selecttaxcountryarea')}>
        <Spin spinning={getStoreCountriesLoading}>
          <div className={css.modalClass}>
            <CheckCountry
              list={list}
              value={checked}
              onChange={onFomValuesChange}
            />
          </div>

          <ModalFooter
            onCancel={hideModal}
            okText={getI18n('general.save')}
            hideOkButton={disable}
            onOk={onModalConfirm}
          />
        </Spin>
      </Modal>
    </Fragment>
  );
};

export default CountrySelect;
